import { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { UseGetType } from "./Types/useGet.types"
import { Context } from "src/context"


export const useGet = <T>({ API, isNotValid = false, depArr = [], params = [], defaultValue, needSpinner, onSuccess }: UseGetType<T>) => {

    const [data, setData] = useState<T>(defaultValue)
    const [error, setError] = useState("")
    const [isPending, setIsPending] = useState(false)
    const [isError, setIsError] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)

    const { i18n } = useTranslation()
    const { setLoading, fetchHealth } = useContext(Context)

    const GetHandler = (APIMethod: Promise<{ data: { data: number | any[] | {} } }>, setData: Function, needSpinner: boolean = true) => {
        needSpinner && setLoading((l: number) => l + 1)
        APIMethod.then((res: { data: { data: number | any[] | {} } }) => {
            setData(res.data.data || defaultValue)
            setIsError(false)
            onSuccess?.()
        }).catch((err: any) => {
            setIsPending(false);
            setIsError(true);
            setError(err?.response?.data?.message || "error");
            if (!err.config.url.includes("live")) {
                fetchHealth();
            }
        }).finally(() => {
            needSpinner && setLoading((l: number) => l - 1)
        })
    }

    useEffect(() => {
        if (!API || isNotValid) return
        setIsPending(true)
        GetHandler(API(...params), (res: any) => {
            setIsPending(false);
            setIsSuccess(true);
            setData(res);
        }, needSpinner);

    }, [i18n, isNotValid, depArr.join(","), JSON.stringify(params)])


    return { data, isPending, error, isError, isSuccess, setData }

}

